import { useTranslation } from 'react-i18next';
import { CustomFieldTypes } from '@/services/dictionaries/CustomFieldTypes';

export const useDataTypes = () => {
    const { t } = useTranslation();
    return [
        {
            value: CustomFieldTypes.Birthday,
            label: t('birthday'),
        },
        {
            value: CustomFieldTypes.Phone,
            label: t('phone'),
        },
        {
            value: CustomFieldTypes.Company,
            label: t('company'),
        },
        {
            value: CustomFieldTypes.Address,
            label: t('address'),
        },
        {
            value: CustomFieldTypes.City,
            label: t('city'),
        },
        {
            value: CustomFieldTypes.PostalCode,
            label: t('postalcode'),
        },
        {
            value: CustomFieldTypes.State,
            label: t('state'),
        },
        {
            value: CustomFieldTypes.Country,
            label: t('country'),
        },
        {
            value: CustomFieldTypes.Consent,
            label: t('consent'),
        },
        {
            value: CustomFieldTypes.Custom,
            label: t('custom'),
        },
    ];
};
